import {QuoteResponseDTO} from "@requests"
import {ref, Ref} from "vue"

const bookingQuoteResponse: Ref<QuoteResponseDTO | null> = ref(null)

export default bookingQuoteResponse